import cn from '@/lib/cs';
import React from 'react';

const DownloadIcon = ({
	className,
	...props
}: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		aria-hidden
		className={cn('h-8 lg:h-12 pointer-events-none', className)}
		{...props}
	>
		<path
			fill="currentColor"
			d="m21 7.4.3.1-.1.3a32 32 0 0 1-5.9 7.9c-.9 1-2 1.8-3.2 2.4-.6.2-1 .1-1.3-.1a22.1 22.1 0 0 1-4.4-4l-3.1-3.1c-.3-.6-.4-1.1-.5-1.7l-.1-.9-.2-.4 1.6-.4c2-.7 3.7 1.2 5 2.8l.3.4A72 72 0 0 1 9.6 2c0-.5.5-.8.9-1.2l.4-.4.3-.4 2.1 2.1v.2l.4 7.9.1.8 1-1.2C16 8.3 17.4 6.6 19 6.5c.7 0 1.4.2 2 .9Z"
		/>
		<path
			fill="currentColor"
			d="M2 22c.8.1 2.7 1.1 3.5 1.2l4 .4 6.7-.5c1.6.1 3.2-.7 4.8-.6.8-.3.5-.6 1.3-.8l.4-1.4c-.3-.4.7-3-.4-2.3a10 10 0 0 1-5.3 1c-2.5 0-5 .6-7.5.5-1.4 0-3.1-.6-4.5-.5-2 .5-5-3-4.2 2.2.8.2.5.6 1.3.8H2Z"
		/>
	</svg>
);

export default DownloadIcon;
